import { ChangeDetectorRef, Component, Input, OnInit, SimpleChanges } from '@angular/core';
import moment from 'moment';
import { Subscription, timer } from 'rxjs';
import { environment } from '../../../environments/environment';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'charla-status',
    template: `
    <span *ngIf="status != 'offline'" class="kt-badge--dot kt-badge"
        [ngClass]="{ 
            'kt-badge--success': status == 'online', 
            'kt-badge--warning': status == 'away' 
        } ">
    </span>
    {{ ( (mode == "label") && status) ? status.charAt(0).toUpperCase() + status.slice(1) : '' }}
        `,
    styles: ['  '],
    imports: [CommonModule]
})
export class StatusComponent implements OnInit {
    
    sub: Subscription;
    status: string = "offline";

    @Input() lastSeen: string;
    @Input() offlineAt: string;
    @Input() mode: string = "badge";

    constructor(private cd: ChangeDetectorRef){

    }
    
    ngOnInit() {
        this.setupTimer();
    }

    calculateStatus(){

        if (this.lastSeen == undefined) {
            this.status = 'offline';
            this.cd.detectChanges();
            return;
        }

        let n = moment.utc();
        let sd = moment.utc( this.lastSeen.replace('T', ' '), 'YYYY-MM-DD HH:mm:ss');

        if (this.offlineAt){
            let off = moment.utc( this.offlineAt.replace('T', ' '), 'YYYY-MM-DD HH:mm:ss');
            if (off > sd){
                this.status = 'offline';
                this.cd.detectChanges();
                return;    
            }
        }

        let diff = Math.abs( n.diff(sd, 'seconds') );
        let st = 'offline';

        if (diff <= (environment.sessionDuration / 2) ) {
            st = 'online';
        }
        else if (diff <= environment.sessionDuration) {
            st = 'away';
        }

        this.status = st;

        this.cd.detectChanges();
    }

    setupTimer(){
        
        if (this.sub) this.sub.unsubscribe();

		this.sub = timer(0, 1000 * 60).subscribe( () => {
			this.calculateStatus();
			//console.debug(`Refreshing visitor status (${this.lastSeen})...`);
        });
        
    }

    ngOnChanges(changes: SimpleChanges): void {
        if( changes['lastSeen'] || changes['offlineAt'] ) {
            this.setupTimer();
        }
    }

    ngOnDestroy() {
        this.sub.unsubscribe();
    }

}